export const SvgNewHome = (props: any) => {
	return (
		<svg
			width="105"
			height="47"
			viewBox="0 0 105 47"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10.6035 33.7403L18.0302 25.5935L18.0302 41.8871L10.6035 33.7403Z"
				fill="#5D83E8"
			/>
			<path
				d="M10.6035 33.7403L18.0302 25.5935L18.0302 41.8871L10.6035 33.7403Z"
				fill="black"
				fillOpacity="0.4"
			/>
			<g filter="url(#filter0_d_6465_26427)">
				<path
					d="M10.6016 10.9609C10.6016 8.77335 12.3749 7 14.5625 7H90.8096C92.9972 7 94.7705 8.77335 94.7705 10.9609V29.7751C94.7705 31.9627 92.9972 33.736 90.8096 33.736H10.6016V10.9609Z"
					fill="#5D83E8"
				/>
			</g>
			<path
				d="M27.6265 16.7398V23.9414H26.4661L23.0727 19.036H23.013V23.9414H21.7084V16.7398H22.8758L26.2656 21.6487H26.3289V16.7398H27.6265ZM30.0382 23.9414V16.7398H34.7221V17.8334H31.3428V19.7885H34.4795V20.8821H31.3428V22.8478H34.7502V23.9414H30.0382ZM38.5589 23.9414L36.5264 16.7398H37.9294L39.227 22.032H39.2938L40.6793 16.7398H41.9557L43.3447 22.0355H43.408L44.7055 16.7398H46.1086L44.0761 23.9414H42.7891L41.3474 18.8883H41.2911L39.8459 23.9414H38.5589ZM51.4499 23.9414V16.7398H52.7544V19.7885H56.0915V16.7398H57.3996V23.9414H56.0915V20.8821H52.7544V23.9414H51.4499ZM66.2438 20.3406C66.2438 21.1166 66.0984 21.7812 65.8077 22.3344C65.5194 22.8853 65.1256 23.3073 64.6262 23.6003C64.1292 23.8933 63.5654 24.0399 62.9348 24.0399C62.3042 24.0399 61.7392 23.8933 61.2399 23.6003C60.7429 23.3049 60.3491 22.8818 60.0584 22.3309C59.7701 21.7776 59.6259 21.1142 59.6259 20.3406C59.6259 19.5646 59.7701 18.9012 60.0584 18.3503C60.3491 17.7971 60.7429 17.3739 61.2399 17.0809C61.7392 16.7878 62.3042 16.6413 62.9348 16.6413C63.5654 16.6413 64.1292 16.7878 64.6262 17.0809C65.1256 17.3739 65.5194 17.7971 65.8077 18.3503C66.0984 18.9012 66.2438 19.5646 66.2438 20.3406ZM64.9321 20.3406C64.9321 19.7944 64.8466 19.3337 64.6755 18.9586C64.5067 18.5812 64.2722 18.2964 63.9722 18.1042C63.6721 17.9096 63.3263 17.8123 62.9348 17.8123C62.5433 17.8123 62.1976 17.9096 61.8975 18.1042C61.5974 18.2964 61.3618 18.5812 61.1907 18.9586C61.0219 19.3337 60.9375 19.7944 60.9375 20.3406C60.9375 20.8868 61.0219 21.3486 61.1907 21.7261C61.3618 22.1011 61.5974 22.386 61.8975 22.5806C62.1976 22.7728 62.5433 22.8689 62.9348 22.8689C63.3263 22.8689 63.6721 22.7728 63.9722 22.5806C64.2722 22.386 64.5067 22.1011 64.6755 21.7261C64.8466 21.3486 64.9321 20.8868 64.9321 20.3406ZM68.4674 16.7398H70.0638L72.2018 21.9581H72.2862L74.4242 16.7398H76.0206V23.9414H74.7688V18.9938H74.702L72.7117 23.9203H71.7763L69.786 18.9833H69.7192V23.9414H68.4674V16.7398ZM78.4315 23.9414V16.7398H83.1154V17.8334H79.7361V19.7885H82.8727V20.8821H79.7361V22.8478H83.1435V23.9414H78.4315Z"
				fill="white"
			/>
			<defs>
				<filter
					id="filter0_d_6465_26427"
					x="0.699335"
					y="0.0684414"
					width="103.973"
					height="46.5408"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="2.97067" />
					<feGaussianBlur stdDeviation="4.95111" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_6465_26427"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_6465_26427"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};
